import * as contact from "../pages/contact[s]/contact";
import * as gallery from "../pages/gallery[s]/gallery";
import * as home from "../pages/home[s]/home";


export const Obj = {

	contact:{
		component:contact.Page,
		path:"/contact",
		url:()=>{
			return "/contact";
		}
	},
	gallery:{
		component:gallery.Page,
		path:"/gallery",
		url:()=>{
			return "/gallery";
		}
	},
	home:{
		component:home.Page,
		path:"/",
		url:()=>{
			return "/";
		}
	}
};


export const Arr = [Obj.contact,Obj.gallery,Obj.home];